module.exports = __webpack_public_path__ + "static/img/es.50623e6a.svg";